import AuthMenu from './Menu';

export default AuthMenu;
